import React from "react"
import styled from "styled-components"
import { colors } from "../../common/colors/app_colors"
import { DeleteIcon } from "../onboarding/invite_member_row"
import Avatar from "../avatar"
import { MultiSelect } from "react-selectize"
import { checkIfEmailIsValid } from "../../util/onboarding_utils"
import { appConsts } from "../../common/constants/app_consts"
import { setupAttendeeUserItemState } from "./attendee_user_matching_item_utils"

const { silver, errorRed, mutedBlue } = colors

export class AttendeeUserMatchingItem extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            attendeeEmail: "",
            options: [],
            selectedMember: [],
            emailIsValid: true,
        }
    }

    componentDidMount() {
        const { userId, attendeeEmail, members } = this.props
        const initialState = setupAttendeeUserItemState(userId, attendeeEmail, members)
        this.setState({ ...initialState })
    }

    componentDidUpdate(prevProps) {
        const { id, userId, attendeeEmail, members } = this.props
        if (
            prevProps.id != id ||
            prevProps.userId != userId ||
            prevProps.attendeeEmail != attendeeEmail
        ) {
            const updatedState = setupAttendeeUserItemState(userId, attendeeEmail, members)
            this.setState({ ...updatedState })
        }
    }

    handleAttendeeEmailChange = ({ target }) => {
        const attendeeEmail = target.value

        const emailIsValid = checkIfEmailIsValid(
            attendeeEmail,
            appConsts.regExEmailValidation,
        )
        this.setState({ attendeeEmail, emailIsValid })

        const { selectedMember } = this.state
        const { guid, updateField } = this.props
        const userId = selectedMember[0] ? selectedMember[0].userId : null
        updateField(guid, attendeeEmail, userId)
    }

    handleSelectChange = userId => {
        const { guid, updateField } = this.props
        updateField(guid, this.state.attendeeEmail, userId)
    }

    select = value => {
        const selectedMember = value[value.length - 1]

        this.setState({
            selectedMember: selectedMember ? [selectedMember] : [],
        })
        this.handleSelectChange(selectedMember ? selectedMember.userId : null)
    }

    renderMember = ({ name, email, id }) => {
        const displayName = `${name}`
        return (
            <div key={id} className="member-item">
                <Avatar emailAddress={email} name={name} showTooltip={false} />
                <span className="member-item-name">{displayName}</span>
            </div>
        )
    }

    render() {
        const { guid, removeField } = this.props

        return (
            <KeyTagMatchingItemWrapper>
                <input
                    onChange={this.handleAttendeeEmailChange}
                    type="text"
                    placeholder="Email Address"
                    value={this.state.attendeeEmail}
                    className={`form-control text-field ${!this.state
                        .emailIsValid && "invalid-field"}`}
                />
                <div className="tag-select">
                    <MultiSelect
                        id="simple-select-style"
                        options={this.state.options}
                        values={this.state.selectedMember}
                        onValuesChange={this.select}
                        theme="bootstrap3"
                        placeholder={"Select Team Member"}
                        renderValue={this.renderMember}
                        renderOption={this.renderMember}
                        closeOnSelect={true}
                    ></MultiSelect>
                </div>
                <DeleteIcon id={guid} action={removeField} />
            </KeyTagMatchingItemWrapper>
        )
    }
}

const KeyTagMatchingItemWrapper = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 0px;
    margin-bottom: 10px;
    align-items: center;
    justify-content: space-between;
    .inline-icon-x {
        margin: 0;
        padding: 0px;
        height: 16px;
        width: 16px;
        cursor: pointer;
    }
    .text-field {
        width: 45%;
        overflow: hidden;
        resize: none;
        border-radius: 4px;
        border: 1px solid ${silver};
        outline: none;
    }
    .text-field:focus {
        border: 1px solid ${silver};
    }
    .invalid-field {
        border-color: ${errorRed};
    }
    .tag-select {
        width: 45%;
    }
    .react-selectize.bootstrap3.root-node .react-selectize-control {
        border-color: #ccc !important;
        outline: none !important;
        box-shadow: none !important;
    }
    .option-wrapper {
        padding: 0.6em;
    }
    .option-wrapper.highlight {
        background: ${mutedBlue} !important;
    }
    .avatar {
        border-radius: 50%;
        margin-right: 5px;
        height: 30px;
        width: 30px;
    }

    .member-item {
        display: flex;
        align-items: center;
        .member-item-name {
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
    .dropdown-menu {
        background-color: white;
    }
    @media (max-width: 1100px) {
        .resizable-input {
            display: none;
        }
        .member-item-name {
            max-width: 200px;
        }
    }
    @media (max-width: 600px) {
        display: flex;
        flex-direction: column;
        .text-field {
            width: 100%;
            margin-bottom: 10px;
        }
        .tag-select {
            width: 100%;
        }
        .member-item-name {
            max-width: 280px;
        }
        .inline-icon-x {
            align-self: flex-end;
            margin-top: 5px;
        }
    }
    @media (max-width: 400px) {
        .member-item-name {
            max-width: 130px;
        }
    }
`



// WEBPACK FOOTER //
// ./src/components/connected_apps/attendee_user_matching_item.jsx